module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customerChat":"Customer chat","welcomeScreen":"Welcome screen","userSelection":"User selection","lastUpdated":"Last updated by {updatedBy} on {updatedAt}"},"es":{"customerChat":"Chat del cliente","welcomeScreen":"Página de bienvenida","userSelection":"Selección de usuario","lastUpdated":"Ultima actualizacion hecha por {updatedBy} en {updatedAt}"}}')
  delete Component.options._Ctor
}
